/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import { Type } from '@sinclair/typebox';

var TypeStringEnum = function TypeStringEnum(values, options) {
  if (options === void 0) {
    options = {};
  }
  return Type.Unsafe(_extends({
    type: 'string',
    "enum": values
  }, options));
};

export { TypeStringEnum };
//# sourceMappingURL=utils.js.map
